module.exports = __webpack_public_path__ + "static/img/retrieve_revoked_submission.76a8378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/retrieve_revoked_submission.png
// module id = nSg2
// module chunks = 1